import { Badge } from "@light-technology/components";
import type { Enrollment, Location } from "../../state/api.types";

type SandboxStatusProps = {
  enrollment: Enrollment;
  location: Location | null | undefined;
};

export const SandboxStatus = (props: SandboxStatusProps) => {
  if (props.enrollment.is_service_active) {
    return (
      <Badge size="sm" color="success" type="pill-color">
        Active
      </Badge>
    );
  }
  if (props.location?.final_service_date) {
    return (
      <Badge size="sm" color="orange" type="pill-color">
        Canceled
      </Badge>
    );
  }
  if (props.enrollment.is_enrollment_finalized) {
    return (
      <Badge size="sm" color="cyan" type="pill-color">
        Reviewing
      </Badge>
    );
  }
  return (
    <Badge size="sm" color="gray" type="pill-color">
      None
    </Badge>
  );
};
